import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import EditIcon from '@/presentation/assets/svg/Edit'
import TimeIcon from '@/presentation/assets/svg/Time'
import Header from '@/presentation/components/Header'
import Aprovation from '@/presentation/pages/Alteration/components/Aprovation'
import Historic from '@/presentation/pages/Alteration/components/Historic'
import { ROUTES } from '@/services/constants/routes'

const AlterationListPage: React.FC = () => {
  const [tabSelected, setTabSelected] = useState('Aprovações')

  const { t } = useTranslation()

  const handleSelectTab = (tab: string) => {
    setTabSelected(tab)
  }

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <Header previousRoute={ROUTES.MAIN} title="Registrar alterações" />

      <div className="flex w-full max-w-[682px] flex-col items-center px-4 py-2">
        {tabSelected === 'Aprovações' && (
          <>
            <h1 className="mb-6 w-full text-left text-[28px] font-bold text-primary">
              {t('CHANGES_AGAIN', 'Alterações')}
            </h1>

            <p className="mb-4 w-full text-left text-gray-500">
              {t(
                'CHECK_ADMIN_RESPONSE',
                'Consulte o retorno da administração e realize o registro de novas alterações no imóvel.'
              )}
            </p>
          </>
        )}

        {tabSelected === 'Histórico' && (
          <>
            <h1 className="mb-6 w-full text-left text-[28px] font-bold text-primary">
              {t('CHANGE_HISTORY', 'Histórico de alterações')}
            </h1>

            <p className="mb-4 w-full text-left text-gray-500">
              {t(
                'TYPES_PHOTOS_DETAILS',
                'Consulte os tipos, fotos e detalhes de alterações realizadas no imóvel.'
              )}
            </p>
          </>
        )}

        <nav className="mb-6 flex flex-wrap items-center gap-6 border-b-primary">
          <button
            className={`flex flex-col items-center justify-center p-2 pb-1 font-bold ${
              tabSelected === 'Aprovações'
                ? 'border-b-4 border-b-primary text-primary'
                : 'border-b-4 border-b-white text-gray-500'
            }`}
            onClick={() => handleSelectTab('Aprovações')}
          >
            <EditIcon
              color={tabSelected === 'Aprovações' ? '#0170B3' : '#858585'}
            />

            {t('CHANGES_AGAIN', 'Alterações')}
          </button>
          <button
            className={`flex flex-col items-center justify-center p-2 pb-1 font-bold ${
              tabSelected === 'Histórico'
                ? 'border-b-4 border-b-primary text-primary'
                : 'border-b-4 border-b-white text-gray-500'
            }`}
            onClick={() => handleSelectTab('Histórico')}
          >
            <TimeIcon
              color={tabSelected === 'Histórico' ? '#0170B3' : '#858585'}
            />

            {t('HISTORIC', 'Histórico')}
          </button>
        </nav>

        {tabSelected === 'Aprovações' && <Aprovation />}

        {tabSelected === 'Histórico' && <Historic />}
      </div>
    </div>
  )
}

export default AlterationListPage
